import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import useTranslation from '../hooks/UseTranslation'

const GuruModal = (props) => {
  const { t } = useTranslation()
  const { isOpen, toggle, onClosed, backdrop, isButtonDisabled } = props
  let { button } = props
  if (props.button !== undefined) {
    if (typeof props.button === 'string')
      button = (
        <Button
          disabled={isButtonDisabled === true}
          color='primary'
          onClick={toggle}
        >
          {props.button}
        </Button>
      )
  } else {
    button = (
      <Button
        disabled={isButtonDisabled === true}
        color='primary'
        onClick={toggle}
      >
        {t('ok')}
      </Button>
    )
  }
  return (
    <Modal
      size={props.size}
      backdrop={backdrop === false ? 'static' : true}
      keyboard={backdrop !== false}
      onClosed={onClosed}
      isOpen={isOpen}
      toggle={toggle}
    >
      <ModalHeader
        tag={typeof props.title === 'string' ? undefined : 'div'}
        toggle={backdrop === false ? () => null : toggle}
      >
        {props.title}
      </ModalHeader>
      <ModalBody>{props.children}</ModalBody>
      {!props.hideFooter && <ModalFooter>{button}</ModalFooter>}
    </Modal>
  )
}

export default GuruModal
